import React from 'react';
import { Link } from 'react-router';
import { Dialog, label } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemOrganizationLevel} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {TextArea, Input} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';

class OrganizationLevel extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryCode: '',
      parentCategory: '',
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }
  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getCapCoQuan.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.capCoQuanQuanLies,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        if(this.state.pageData.number > 0){
          this.state.pageData.number -= 1;
          this.getListData();
        }
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }
  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if(this.checkValidate()){
      let params = {
        ma: this.state.categoryCode.trim(),
        ten: this.state.categoryName.trim(),
        moTa: this.state.categoryDesc.trim()
      };
      if (this.state.parentCategory) {
        params.cha = {
          id: this.state.parentCategory.capCoQuanQuanLyId
        };
      }
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateCapCoQuan({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postCapCoQuan('',params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if(categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteCapCoQuan({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {

    this.toggleDialog();
    this.setState({
      addType:0,
      categoryCode: '',
      categoryName: '',
      parentCategory: '',
      categoryDesc: '',
      isValid: true
    });
  }

  openAddMoreCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:1,
      categoryId: '',
      categoryCode: '',
      categoryName: '',
      parentCategory: item,
      categoryDesc: '',
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:2,
      categoryId: item.capCoQuanQuanLyId,
      categoryCode: item.ma,
      categoryName: item.ten,
      parentCategory: item.capCoQuanQuanLyCha,
      categoryDesc: item.moTa,
      isValid: true
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-reception"></i>Cấp cơ quan</p>
          </div>
          <div className="right-content">
            {
              CheckPermission('CAPCOQUANQUANLY_THEM') ?
                <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              : null
            }
          </div>
        </div>
        <div className="bottom-content">
          <Search parents={this}/>
          <DataTable
            header = {header.categoryGroup.organizationlevel}
            dataList={this.state.data}
            pageData={this.state.pageData}
            parent= {this}
            hideButtonExport
            tableLoading = {this.state.tableLoading}
          >
            <RowItemOrganizationLevel/>
          </DataTable>
        </div>
        <Dialog
          isOpen={this.state.popupAddCategory}
          onClose={this.toggleDialog.bind(this)}
          title={this.state.addType == 2 ? 'Chỉnh sửa cấp cơ quan' : 'Thêm mới cấp cơ quan'}
          iconName="add-new"
          className="panel-popup category">
          <div className="pt-dialog-body">
            <Input className="" label="Tên" value={this.state.categoryName} require={true} maxLength={40} onChange={this.onChange.bind(this, 'categoryName')} bindValidator={this} channel="danhMuc"/>

            {this.state.parentCategory ? (
              <label className="pt-label">
               Cấp cơ quan cha: {this.state.parentCategory.ten}
              </label>
            ) : null}
            <Input className="" label="Mã" value={this.state.categoryCode} require={true} maxLength={40} onChange={this.onChange.bind(this, 'categoryCode')} bindValidator={this} channel="danhMuc"/>
            <TextArea label="Mô tả" maxLength={255} rows={5} value={this.state.categoryDesc} onChange={this.onChange.bind(this, 'categoryDesc')} className=''/>
          </div>
          <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
          </div>
        </Dialog>
      </div>
      </MasterLayout>
    );
  }
}

OrganizationLevel.defaultProps = {
  validators: {}
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(OrganizationLevel);



// WEBPACK FOOTER //
// ./src/components/modules/category/OrganizationLevel.jsx